import hotkey from "./utils-js/hotKey"
import hkCombos from './hotKeyCombos'
import { dom } from './utils-js'

let cm = hkCombos.getCombosMap()

let systemHotKeyGroupView = new hotkey.HotKeyGroup(
    "view",
    "视图",
    [
        // terminal 下和 VIM 的 redo 快捷键冲突
        // new hotkey.HotKey(
        //     "reload",
        //     cm.get("reload"),
        //     dom.disableCloseConfirm,
        //     "重新加载",
        // ),
        new hotkey.HotKey(
            "forceReload",
            cm.get("forceReload"),
            dom.disableCloseConfirm,
            "强制重新加载",
        ),
        new hotkey.HotKey(
            "devMode",
            cm.get("devMode"),
            () => { console.log("Enter dev mode by hotkey") }, // 浏览器提供功能
            "开发者模式",
        ),
        new hotkey.HotKey(
            "actualSize",
            cm.get("actualSize"),
            null, // 浏览器提供功能
            "按默认比例显示",
        ),
        new hotkey.HotKey(
            "zoomIn",
            cm.get("zoomIn"),
            null, // 浏览器提供功能
            "放大",
        ),
        new hotkey.HotKey(
            "zoomOut",
            cm.get("zoomOut"),
            null, // 浏览器提供功能
            "缩小",
        ),
        new hotkey.HotKey(
            "toggleFullscreen",
            cm.get("toggleFullscreen"),
            () => { console.log("Fullscreen by F11") }, // 浏览器提供功能, 如果这里不是函数, terminal 会拦截事件
            "全屏/退出全屏",
        ),
    ],
    false,  // 系统提供的功能, 无需绑定, 但实际上在 terminal 的按键拦截逻辑中还是会被执行(callback 是有效 function 的话)
    false,
)

let systemHotKeyGroupEdit = new hotkey.HotKeyGroup(
    "edit",
    "编辑",
    [
        new hotkey.HotKey(
            "undo",
            cm.get("undo"),
            null, // 浏览器提供功能
            "撤销操作",
        ),
        new hotkey.HotKey(
            "redo",
            cm.get("redo"),
            null, // 浏览器提供功能
            "恢复操作",
        ),
        new hotkey.HotKey(
            "cut",
            cm.get("cut"),
            null, // 浏览器提供功能
            "剪切",
        ),
        new hotkey.HotKey(
            "copy",
            cm.get("copy"),
            null, // 浏览器提供功能
            "复制",
        ),
        new hotkey.HotKey(
            "paste",
            cm.get("paste"),
            null, // 浏览器提供功能
            "粘贴",
        ),
        new hotkey.HotKey(
            "selectAll",
            cm.get("selectAll"),
            null, // 浏览器提供功能
            "全选",
        ),
    ],
    false,
    false,
)

let systemHotKeyGroupWindow = new hotkey.HotKeyGroup(
    "window",
    "窗口",
    [
        new hotkey.HotKey(
            "minimizeWin",
            cm.get("minimizeWin"),
            () => { console.log("Minimize Window by hotkey") }, // 浏览器提供功能
            "最小化",
        ),
        // CTRL+W 关闭窗口快捷键和命令行删除最后一个单词的快捷键冲突
        // new hotkey.HotKey(
        //     "closeWin",
        //     cm.get("closeWin"),
        //     () => { console.log("Close Window by hotkey") }, // 浏览器提供功能
        //     "关闭",
        // ),
    ],
    true,
    false,
)

let systemHotKeyGroups = new Map()
systemHotKeyGroups.set(systemHotKeyGroupView.name, systemHotKeyGroupView)
systemHotKeyGroups.set(systemHotKeyGroupEdit.name, systemHotKeyGroupEdit)
systemHotKeyGroups.set(systemHotKeyGroupWindow.name, systemHotKeyGroupWindow)

export default {
    systemHotKeyGroupView,
    systemHotKeyGroupEdit,
    systemHotKeyGroupWindow,
    systemHotKeyGroups,
}
